import Vue from 'vue'

const state = {
  emailFlowStates: {}, // Keyed by charityId
}

// getters
const getters = {
  getEmailFlowState: (state) => (charityId) => {
    if (charityId in state.emailFlowStates) {
      return state.emailFlowStates[charityId]
    }

    return null
  },
}

// actions
const actions = {
  saveEmailFlowState({ commit }, { charityId, flowState }) {
    commit('UPDATE_EMAIL_FLOW_STATE', { charityId, flowState })
  },
}

// mutations
const mutations = {
  UPDATE_EMAIL_FLOW_STATE(state, { charityId, flowState }) {
    if (flowState && Object.keys(flowState).length > 0) {
      Vue.set(state.emailFlowStates, charityId, flowState)
    } else {
      Vue.delete(state.emailFlowStates, charityId)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
